export const AR_ERROR_KINDS = {
  GENERIC: 'generic',
  NOT_FOUND: 'notFound',
  CAMERA_DENIED: 'cameraDenied',
  UNSUPPORTED: 'unsupported',
} as const;

// `reason` values 8th Wall passes to onCameraStatusChange when the camera cannot start.
export const XR8_CAMERA_FAILURE = {
  DENY_CAMERA: 'DENY_CAMERA',
  NO_CAMERA: 'NO_CAMERA',
  UNSPECIFIED: 'UNSPECIFIED',
} as const;

// Public AR requests give up after this long, so a stalled connection ends on the generic error (with Try
// again) instead of an endless spinner. Scoped to the AR calls: editor uploads use the same axios client.
export const AR_REQUEST_TIMEOUT_MS = 15000;
